import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import { pickAvatarGradient, getInitials, grey } from '../../theme/tones';

/**
 * Avatar de liste : dégradé déterministe calculé à partir du libellé, donc
 * stable d'un écran à l'autre pour une même entité. Les initiales servent
 * de repli quand il n'y a pas d'image.
 */
const ListAvatar = ({ src, name = '', size = 46, fallback = '??', sx = {}, ...other }) => {
  const [from, to] = pickAvatarGradient(name);

  return (
    <Avatar
      src={src || undefined}
      sx={{
        height: size,
        width: size,
        borderRadius: `${Math.round(size * 0.3)}px`,
        fontSize: size > 40 ? '0.95rem' : '0.8rem',
        fontWeight: 800,
        color: grey(0),
        flexShrink: 0,
        border: '2px solid',
        borderColor: 'background.paper',
        boxShadow: `0 6px 16px ${from}40`,
        background: `linear-gradient(135deg, ${from} 0%, ${to} 100%)`,
        ...sx
      }}
      {...other}
    >
      {getInitials(name, fallback)}
    </Avatar>
  );
};

ListAvatar.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.number,
  fallback: PropTypes.string,
  sx: PropTypes.object
};

export default ListAvatar;
